import picWeatherApp from "../../../assets/projects/picWeatherApp.jpg";
import picHenrysBurger from "../../../assets/projects/picHenrysBurger.jpg";
import picRecipesYa from "../../../assets/projects/picRecipesYA.jpg";
import picCotizApp from "../../../assets/projects/picCotizApp.jpg";
import picPortfolio from "../../../assets/projects/picPortfolio.jpg";
import picAlkyBankWallet from "../../../assets/projects/picAlkyBankWallet.jpg";
import useModal from "../../../hooks/useModal";
import ProjectCard from "./ProjectCard";

import "../../css/Project.css";

export default function Project() {

   const [isOpenMoreModal0, openMoreModal0, closeMoreModal0] = useModal();
   const [isOpenMoreModal1, openMoreModal1, closeMoreModal1] = useModal();
   const [isOpenMoreModal2, openMoreModal2, closeMoreModal2] = useModal();
   const [isOpenMoreModal3, openMoreModal3, closeMoreModal3] = useModal();
   const [isOpenMoreModal4, openMoreModal4, closeMoreModal4] = useModal();
   const [isOpenMoreModal5, openMoreModal5, closeMoreModal5] = useModal();
   const [isOpenMoreModal6, openMoreModal6, closeMoreModal6] = useModal();

   const myProjects = [
      {
         title: "Red social (en proceso...)",
         pic: undefined,
         descriptionMini: "Permite agregar amigos, chatear, crear publicaciones, entre otras cosas.",
         techs: ["Java", "Spring Boot", "Hibernate", "JPA", "MySQL", "JDBC", "JWT", "MVC"],
         deploy: undefined,
         repo: "https://github.com/siprem10/socialNetwork",
         review: undefined,
         type: "Backend",
         more: true,
         aditionalInfo: `Estoy desarrollando una red social en Spring Boot, pronto será publicada!`,
         teamList: undefined,
         modal: { isOpen: isOpenMoreModal6, open: openMoreModal6, close: closeMoreModal6 }
      },
      {
         title: "Henrys Burger",
         pic: picHenrysBurger,
         descriptionMini: "Permite realizar la compra de comida rápida con facilidad y rapidez.",
         techs: ["HTML", "CSS", "JavaScript", "Node", "Express", "Sequelize", "PostgreSQL", "React", "Redux"],
         deploy: "https://henrys-app.vercel.app/",
         repo: "https://github.com/mabhyHs/Henrys-app",
         review: "https://www.youtube.com/watch?v=WN5D9ic8_XY",
         type: "Full-Stack {Scrum}",
         more: true,
         aditionalInfo: `Diseño y desarrollo Full-stack, participación activa en un equipo de desarrollo ágil con
         metodología SCRUM en sprints de una semana presentando a
         un Product Owner avances en el desarrollo de la app.`,
         teamList: [
            { name: "Mailén Huens", href: "https://github.com/mabhyHs" },
            { name: "Federico Leiras", href: "https://github.com/FLeiras" },
            { name: "Juan Cruz", href: "https://github.com/PJuanCruz" },
            { name: "Mauro Rodriguez", href: "https://github.com/maurorodriguez" },
            { name: "Pablo García Moralez", href: "https://github.com/pablogarciamoralez" },
            { name: "Ramiro Joaquín Domínguez (Yo)", href: "https://github.com/siprem10" }
         ],
         modal: { isOpen: isOpenMoreModal2, open: openMoreModal2, close: closeMoreModal2 }
      },
      {
         title: "AlkyBank Wallet",
         pic: picAlkyBankWallet,
         descriptionMini: "Permite realizar transacciones (carga de saldo, transferencias y pago de servicios).",
         techs: ["HTML", "CSS", "JavaScript", "Node", "Express", "Sequelize", "MySQL", "Vite", "React", "Redux"],
         deploy: "https://alky-bank-wallet.vercel.app/",
         repo: undefined,
         review: "https://www.youtube.com/watch?v=qSmJsLEYkhU",
         type: "Full-Stack {Scrum}",
         more: true,
         aditionalInfo: `Diseño y Desarrollo Full-Stack en equipo, simulando un entorno laboral aplicando metodologías agiles (SCRUM).`,
         teamList: [
            { name: "Alberto Gómez Juan", href: "https://www.linkedin.com/in/agomezjuan/" },
            { name: "Luciano Piñol", href: "" },
            { name: "Ramiro Joaquín Domínguez (Yo)", href: "https://www.linkedin.com/in/rami-dominguez-full-stack/" }
         ],
         modal: { isOpen: isOpenMoreModal5, open: openMoreModal5, close: closeMoreModal5 }
      },
      {
         title: "Weather App",
         pic: picWeatherApp,
         descriptionMini: "Permite buscar el clima y pronóstico extendido de cualquier ciudad.",
         techs: ["HTML", "CSS", "TypeScript", "React", "Redux", "Bootstrap"],
         deploy: "https://weather-app-rosy-zeta.vercel.app/",
         repo: "https://github.com/siprem10/Weather-app",
         review: "https://www.youtube.com/watch?v=sPvVBmdgrA4",
         type: "Frontend {Autodidácta}",
         more: true,
         aditionalInfo: `Desarrollo Frontend con React, estilado con Bootstrap, y consumo de API REST para obtener info actualizada del clima.`,
         teamList: undefined,
         modal: { isOpen: isOpenMoreModal1, open: openMoreModal1, close: closeMoreModal1 }
      },
      {
         title: "Recipes YA",
         pic: picRecipesYa,
         descriptionMini: "Permite buscar información sobre recetas de cocina.",
         techs: ["HTML", "CSS", "JavaScript", "Node", "Express", "Sequelize", "PostgreSQL", "React", "Redux"],
         deploy: "https://pi-food-deploy-eight.vercel.app/",
         repo: "https://github.com/siprem10/pi-food-deploy",
         review: "https://www.youtube.com/watch?v=qVuw29yqahw",
         type: "Full-Stack {Autodidácta}",
         more: true,
         aditionalInfo: `Desarrollo de app web Full-Stack, diseño y consumo de API REST.
         Cuenta con funcionalidades de
         búsqueda, ordenamiento, filtrado, paginado y CRUD de recetas.`,
         teamList: undefined,
         modal: { isOpen: isOpenMoreModal3, open: openMoreModal3, close: closeMoreModal3 }
      },
      {
         title: "Cotiz App",
         pic: picCotizApp,
         descriptionMini: "Permite realizar presupuestos, pedidos, carga de productos y más...",
         techs: ["Java", "SQLite", "XML", "Android"],
         deploy: undefined,
         repo: undefined,
         review: undefined,
         type: "Android {Autodidácta}",
         more: true,
         aditionalInfo: `Construí una app Android en Java con el objetivo de generar rápidamente presupuestos y mantener al día la cotización,
         además permite gestionar stock de productos, actualización masiva de lista de precios,
         realización de pedidos en pesos o en dólares, y mucho más.`,
         teamList: undefined,
         modal: { isOpen: isOpenMoreModal4, open: openMoreModal4, close: closeMoreModal4 }
      },
      {
         title: "Portafolio",
         pic: picPortfolio,
         descriptionMini: "Permite ver información sobre mi.",
         techs: ["HTML", "CSS", "TypeScript", "React"],
         deploy: undefined,
         repo: undefined /*"https://github.com/siprem10/Personal-Portfolio"*/,
         review: undefined,
         type: "Frontend {Autodidácta}",
         more: true,
         aditionalInfo: `Diseño y desarrollo de app web Frontend, implementación de custom hooks, tema oscuro/claro.`,
         teamList: undefined,
         modal: { isOpen: isOpenMoreModal0, open: openMoreModal0, close: closeMoreModal0 }
      },
   ];

   return (
      <div className="project fadeIn">
         <h1 className="title-tech-project">PROYECTOS</h1>
         <div className="content-project">
            {myProjects?.map((project, i) =>
               <ProjectCard project={project} key={i} />
            )}
         </div>
      </div>
   );
}